import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import ActionRequired from "./ActionRequired";
import ActionRequested from "./ActionRequested";
import Delivered from "./Delivered";
import { DateRangePicker } from "react-date-range";
import RTO from "./RTO";
import axios from "axios";

const NdrPage = () => {


  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [orders, setOrders] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [ndrData, setNdrData] = useState([]);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(""); // Add this line
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orderIds, setOrderIds] = useState("");
  const [awbNumbers, setAwbNumbers] = useState("");
  const [productName, setProductName] = useState("");
  const [channel, setChannel] = useState("");
  const [type, setType] = useState("");
  const [courier, setCourier] = useState("");
  const [attempts, setAttempts] = useState("");
  const location = useLocation()
  const { id } = useParams();


  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const tabs = ["Action Required", "Action Requested", "Delivered", "RTO"];
  const isNdrRoute = location.pathname === "/dashboard/ndr";
  const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(tabStorageKey) || "Action Required";
  });

  useEffect(() => {
    localStorage.setItem(tabStorageKey, activeTab);
  }, [activeTab]);

  const toggleFilters = () => {
    if (filtersApplied) {
      clearFilters();
      setFiltersApplied(false);
    } else {
      setShowFilters((prev) => !prev);
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const [session, token] = document.cookie.split("=");
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setOrders(response.data.orders);
        setRefresh(false);
        setNdrData(response.data?.orders.ndrHistory || []);

        // console.log(orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [refresh]);

  const applyFilters = () => {
    let filteredOrders = [...orders];

    // Normalize date filtering to ignore time for today, yesterday, etc.
    if (startDate && endDate) {
      const filterStart = new Date(startDate);
      const filterEnd = new Date(endDate);

      // Set time to midnight for startDate and 23:59:59 for endDate
      filterStart.setHours(0, 0, 0, 0);
      filterEnd.setHours(23, 59, 59, 999);

      filteredOrders = filteredOrders.filter((order) => {
        if (order.ndrReason?.date) {
          const orderDate = new Date(order.ndrReason.date);
          orderDate.setHours(0, 0, 0, 0); // Reset the time for comparison
          return orderDate >= filterStart && orderDate <= filterEnd;
        }
        return false;
      });
    }

    // Filter by Order IDs
    if (orderIds) {
      const ids = orderIds.split(",").map((id) => id.trim());
      filteredOrders = filteredOrders.filter(
        (order) => order.orderId && ids.includes(order.orderId.toString())
      );
    }

    // Filter by AWB Numbers
    if (awbNumbers) {
      const awbs = awbNumbers.split(",").map((awb_number) => awb_number.trim());
      filteredOrders = filteredOrders.filter(
        (order) => order.awb_number && awbs.includes(order.awb_number.toString())
      );
    }

    // Filter by Product Name
    if (productName) {
      filteredOrders = filteredOrders.filter(
        (order) => order.productName && order.productName.toLowerCase().includes(productName.toLowerCase())
      );
    }

    // Filter by Channel
    if (channel) {
      filteredOrders = filteredOrders.filter(
        (order) => order.channel && order.channel.toLowerCase() === channel.toLowerCase()
      );
    }

    // Filter by Courier
    if (courier) {
      filteredOrders = filteredOrders.filter(
        (order) => order.courierServiceName && order.courierServiceName.toLowerCase() === courier.toLowerCase()
      );
    }

    // Filter by Attempt Count
    if (attempts) {
      filteredOrders = filteredOrders.filter(
        (order) => order.ndrHistory && order.ndrHistory.length === parseInt(attempts)
      );
    }

    // Filter by Payment Type (if applicable)
    if (type) {
      filteredOrders = filteredOrders.filter(
        (order) => order.paymentDetails && order.paymentDetails.method && order.paymentDetails.method.toLowerCase() === type.toLowerCase()
      );
    }

    setFilteredOrders(filteredOrders);
    setShowFilters(false);
    setFiltersApplied(true);
  };




  const clearFilters = () => {
    setDateFilter('');
    setShowCustomCalendar(false);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
    setOrderIds('');
    setAwbNumbers('');
    setType('');
    setCourier('');
    setAttempts('');
    setChannel('');
    setFiltersApplied(false);
    setFilteredOrders(orders);
  };


  const renderTabContent = () => {
    switch (activeTab) {
      case "Action Required":
        return <ActionRequired orders={filteredOrders} />;
      case "Action Requested":
        return <ActionRequested orders={filteredOrders} />;
      case "Delivered":
        return <Delivered orders={filteredOrders} />;
      case "RTO":
        return <RTO orders={filteredOrders} />;
      default:
        return <div>Select a tab to view orders.</div>;
    }
  };

  const handleDateSuggestion = (value) => {
    let startDate, endDate;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to the start of the day

    switch (value) {
      case "today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case "yesterday":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(startDate);
        break;

      case "last7days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6); // 6 days before today (including today)
        endDate = new Date(today);
        break;

      case "thismonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today);
        break;

      case "lastmonth":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
        break;

      case "thisyear":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today);
        break;

      case "custom":
        setShowCustomCalendar(true); // Open the calendar for custom selection
        return; // Exit early

      default:
        return;
    }

    // Update state properly
    setSelectionRange({ startDate, endDate, key: "selection" });
    setStartDate(startDate);
    setEndDate(endDate);
    setShowCustomCalendar(false); // Close the calendar for predefined options
  };

  const applyDateFilter = (dateRange) => {
    const { startDate, endDate } = dateRange;
    setFromDate(startDate);
    setEndDate(endDate);

    // Apply filter logic based on startDate and endDate
  };

  const getToday = () => {
    const today = new Date();
    return { startDate: today, endDate: today };
  };

  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return { startDate: yesterday, endDate: yesterday };
  };

  const getLast7Days = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 7 days ago
    return { startDate: sevenDaysAgo, endDate: today };
  };

  const getThisMonth = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: firstDayOfMonth, endDate: today };
  };

  const getThisYear = () => {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    return { startDate: firstDayOfYear, endDate: today };
  };
  const handleDateChange = (ranges) => {
    setSelectionRange(ranges.selection);
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };



  // flex flex-col md:flex-row justify-between items-center gap-4
  return (
    <div
      className={`md:p-2 lg:p-2 ${showModal ? "overflow-hidden" : ""
        }`}
    >
      {!id && (
        <div className="mb-1">
          <h1 className="text-[12px] md:text-[18px] text-gray-700 font-[600]">NDR</h1>
        </div>
      )}

      <div className="flex justify-between items-center md:grid md:grid-cols-2 md:w-auto w-full">
        <div className="hidden md:flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-3 py-2 text-gray-700 text-[12px] md:text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                ? "bg-[#0CBB7D] text-white"
                : "bg-white text-gray-700 hover:bg-green-200"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        
      </div>

      <div
        className={`overflow-hidden transition-max-height duration-700 ease-in-out ${showFilters ? "max-h-[600px]" : "max-h-0"
          }`}
      >
        {showFilters && (
          <div className="w-full  mt-2 rounded-lg show-filters">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <select
                  className="w-full p-2 text-[12px] border rounded-md focus:outline-none"
                  value={dateFilter}
                  onChange={(e) => {
                    setDateFilter(e.target.value);
                    handleDateSuggestion(e.target.value);
                  }}
                >
                  <option value="">Select Date Range</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last7days">Last 7 Days</option>
                  <option value="thismonth">This Month</option>
                  <option value="lastmonth">Last Month</option>
                  <option value="thisyear">This Year</option>
                  <option value="custom">Custom Range</option>
                </select>

                {showCustomCalendar && (
                  <div className="absolute bg-white border rounded-lg shadow-md p-2 mt-2 z-50 w-[90%] max-w-md sm:w-full overflow-hidden">
                    <div className="overflow-x-auto max-w-full">
                      <DateRangePicker
                        ranges={[selectionRange]}
                        onChange={handleDateChange}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        className="text-[12px] sm:text-base"
                      />
                    </div>
                    <button
                      className="mt-2 px-3 py-1 text-[12px] bg-blue-500 text-white rounded-md w-full sm:w-auto sm:text-[12px] sm:px-6 sm:py-2"
                      onClick={() => setShowCustomCalendar(false)}
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>

              <div>
                <input
                  type="text"
                  placeholder="Order IDs"
                  className="w-full p-1.5 text-[12px] border rounded-md focus:outline"
                  value={orderIds}
                  onChange={(e) => setOrderIds(e.target.value)}
                />
              </div>

              <div>
                <input
                  type="text"
                  placeholder="AWB Numbers"
                  className="w-full p-1 text-[12px] border rounded-md focus:outline"
                  value={awbNumbers}
                  onChange={(e) => setAwbNumbers(e.target.value)}
                />
              </div>

              <div>
                <select
                  className="w-full p-[7px] text-[12px] border rounded-md focus:outline-none"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="">Select Type</option>
                  <option value="COD">COD</option>
                  <option value="Prepaid">Prepaid</option>
                </select>
              </div>

              <div>
                <select
                  className="w-full p-[7px] text-[12px] border rounded-md focus:outline-none"
                  value={courier}
                  onChange={(e) => setCourier(e.target.value)}
                >
                  <option value="">Select Courier</option>
                  {Array.from(
                    new Set(orders.map((order) => order.courierServiceName))
                  )
                    .filter(Boolean)
                    .map((courier, index) => (
                      <option key={index} value={courier}>
                        {courier}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <select
                  className="w-full p-[7px] text-[12px] border rounded-md focus:outline-none"
                  value={attempts}
                  onChange={(e) => setAttempts(e.target.value)}
                >
                  <option value="">Select Attempts</option>
                  {Array.from(
                    new Set(
                      orders
                        .flatMap((order) =>
                          order.ndrHistory ? order.ndrHistory.map((n) => n.attempt) : []
                        )
                        .filter(Boolean)
                    )
                  )
                    .sort((a, b) => a - b)
                    .map((attempt, index) => (
                      <option key={index} value={attempt}>
                        {attempt}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <select
                  className="w-full p-[7px] text-[12px] border rounded-md focus:outline-none"
                  value={channel}
                  onChange={(e) => setChannel(e.target.value)}
                >
                  <option value="">Select Channel</option>
                  <option value="custom">Custom Orders</option>
                </select>
              </div>
            </div>

            <div className="mt-4 flex justify-end">
              <button
                className="bg-[#0CBB7D] text-white px-4 py-1.5 rounded-lg transition-all text-[12px]"
                onClick={() => {
                  setFiltersApplied(true);
                  setShowFilters(false);
                  applyFilters();
                }}
              >
                Apply
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="relative md:hidden mb-2">
        <button
          className="w-full px-4 py-2 bg-[#0CBB7D] text-white rounded-lg text-sm flex justify-between items-center"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {activeTab} <span className="ml-2">▼</span>
        </button>
        {showDropdown && (
          <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-lg shadow-lg z-[70] font-[600]">
            {tabs.map((tab) => (
              <button
                key={tab}
                className="w-full text-left px-4 py-2 text-sm hover:bg-gray-200"
                onClick={() => {
                  setActiveTab(tab);
                  setShowDropdown(false);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="overflow-x-auto">{renderTabContent()}</div>
    </div>
  );
};

export default NdrPage;